<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
        :model="consultTeacherInfo"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
    >
      <el-form-item label="头衔" prop="rank">
        <el-input
            v-model="consultTeacherInfo.rank"
            maxlength="30"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>

      <el-form-item label="学习人数" prop="consult_num">
        <el-input v-model="consultTeacherInfo.consult_num" style="width:33%"></el-input>
      </el-form-item>
      <el-form-item label="服务时长" prop="service_duration">
        <el-input v-model="consultTeacherInfo.service_duration" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="从业年限" prop="working_hours">
        <el-input v-model="consultTeacherInfo.working_hours" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item  prop="cert" label="资质证书">
        <el-input v-model="consultTeacherInfo.cert" style="width:50%"></el-input>
      </el-form-item>

<!--      <el-form-item  label="个案咨询标签" prop="consult_teacher_tag_id">
        <el-select
            multiple
            filterable
            class="search-el"
            size="mini"
            v-model="consultTeacherInfo.consult_teacher_tag_id"
            placeholder="请选择"
            clearable
        >
          <el-option
              v-for="item in consult_tag"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item label="个案咨询标签" prop="consult_teacher_tag_id">
<!--        <template>
          <div>
            <el-checkbox-group v-model="checkboxGroup1">
              <el-checkbox-button v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox-button>
            </el-checkbox-group>
          </div>
          <div style="margin-top: 20px">
            <el-checkbox-group v-model="checkboxGroup2" size="medium">
              <el-checkbox-button v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox-button>
            </el-checkbox-group>
          </div>
        </template>-->

        <el-select v-model="consultTeacherInfo.consult_teacher_tag_id" placeholder="请选择" multiple filterable>
          <el-option-group
              v-for="group in this.consult_tag"
              :key="group.id"
              :label="group.name">
            <el-option
                v-for="item in group.childTag"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-form-item label="个案咨询级别" prop="consult_teacher_tag_id">
        <el-select v-model="consultTeacherInfo.level" placeholder="请选择">
            <el-option
                v-for="item in consultTeacherLevel"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="个人介绍" prop="intro">
        <tinymce v-model="consultTeacherInfo.intro" style="width:66%"></tinymce>
      </el-form-item>


      <el-form-item>
        <el-button
            size="small"
            type="primary"
            @click="
            createUpdateTeacherExtra()
          "
            :loading="updateLoading"
        >确 定</el-button
        >
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import tinymce from '@/components/tinymce.vue';

import {
  /*beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,*/
} from "@/api/common";

import {
  createUpdateTeacherExtra,
  consultTeacherExtraInfo,
  consultTagList
} from "@/api/consult";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      editor: null,
      consultTeacherInfo: {
        id: 0,
        teacher_id: this.$route.query.teacher_id,
        rank: "",
        consult_num: 0,
        service_duration: 0,
        working_hours: 0,
        cert: '',
        intro: '',
        consult_teacher_tag_id: [],
      },
      consultTeacherLevel:[
        {key:'', value:'暂无',},
        {key:'internship', value:'实习',},
        {key:'novice', value:'新手',},
        {key:'mature', value:'成熟',},
        {key:'senior', value:'资深',},
      ],
      consult_tag:[]
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    this.consultTeacherInfo.teacher_id = this.$route.query.teacher_id;
    if (this.consultTeacherInfo.teacher_id > 0) {
      this.getInfo();
    }
    consultTagList({all:true}).then((response) => {
      this.consult_tag = response.data;
      let tags = this.consult_tag;
      let tag_arr = [];
      tags.forEach(function (v){
        if(v.pid == 0){
          tag_arr.push(v)
        }
      })
      tag_arr.forEach(function (v,i){
        let childTag = [];
        tags.forEach(function (val){
          if(v.id == val.pid){
            childTag.push(val)
          }
        })
        tag_arr[i].childTag = childTag;
      })
      this.consult_tag = tag_arr;
    })
  },
  mounted() {
  },
  methods: {
    /*beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.meetStoryInfo.img_url = fileUrl
        });
      });
    },*/

    getInfo() {
      this.loading = true;
      consultTeacherExtraInfo({
        teacher_id: this.consultTeacherInfo.teacher_id,
      }).then((response) => {
        if(response.data.length != 0){
          this.consultTeacherInfo = response.data;
        }
        this.loading = false;
      });
    },
    createUpdateTeacherExtra() {
      this.updateLoading = true;
      createUpdateTeacherExtra(this.consultTeacherInfo)
          .then((response) => {
            this.updateLoading = false;
            if (response.code == 1) {
              this.$message.success(response.message);
              this.getInfo()
              /*this.$router.push({
                path: "/story/meetStoryList",
                query: {
                  category: this.$route.query.category,
                }
              });*/
            }
          })
          .catch((err) => {
            this.updateLoading = false;
          });
    },

    ref() {
      window.history.go(-1);
    },

  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>